/* eslint-disable react/prop-types */
import React, {useState} from 'react';
import NavigationLink from 'components/NavigationLink';
import UserIcon from 'assets/svgs/sidebar/user.svg';
import PostsIcon from 'assets/svgs/sidebar/post.svg';
import CompanyIcon from 'assets/svgs/sidebar/partner.svg';
import InformationIcon from 'assets/svgs/sidebar/information.svg';
import ReaderIcon from 'assets/svgs/sidebar/reader.svg';
import AdminIcon from 'assets/svgs/sidebar/admin.svg';
import SellerIcon from 'assets/svgs/sidebar/seller.svg';
import JudgeIcon from 'assets/svgs/sidebar/judge.svg';
import EditorIcon from 'assets/svgs/sidebar/editor.svg';
import NavigationIcon from 'assets/svgs/sidebar/navigation.svg';
import PageIcon from 'assets/svgs/sidebar/page.svg';
import SidebarProfile from 'components/SidebarProfile';
// import { ReactComponent as UploadIcon } from 'assets/svgs/categories/upload.svg';
import {makeSelectBasicUser} from 'reducers/selectors/userSelectors';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import messages from './messages';
import './sidebar.scss';
import EditProfile from './EditProfile';
import {isAdmin, isJudge, isPartner, isReader, isStaffHasPermission} from '../../utils/role';
import JudgeSidebarItems from './JudgeSidebar';

const basicUserSelector = makeSelectBasicUser();

export default function Sidebar() {
  const userDetails = useSelector(basicUserSelector);
  // const roles = useSelector(state => state.roles.roles);
  // const role = roles
  //   ? roles.find(f => f._id === userDetails.masterRoleId._id)
  //   : null;
  // const role = userDetails.masterRoleId;
  const {roles} = userDetails;
  const showBlogPost = isStaffHasPermission(roles, ['project', 'product']);
  const showBlogCompany = isStaffHasPermission(roles, [
    'profile',
    'about',
    'partner',
    'cloud',
  ]);
  const showBlogInformation = isStaffHasPermission(roles, ['info']);
  const showBlog = showBlogPost || showBlogCompany || showBlogInformation;

  const showBoardReader = isAdmin(roles);
  const showBoardPartner = isAdmin(roles);
  const showBoardAdmin = isAdmin(roles);
  const showBoardSeller = isAdmin(roles);
  const showBoardJudge = isAdmin(roles);
  const showBoardEditor = isAdmin(roles);
  const showBoard = showBoardReader || showBoardPartner || showBoardAdmin;

  const showCategoryPost = isStaffHasPermission(roles, ['category']);
  const showCategoryCompany = isStaffHasPermission(roles, ['category']);
  const showCategoryInformation = isStaffHasPermission(roles, ['category']);
  const showCategory =
    showCategoryPost || showCategoryCompany || showCategoryInformation;

  const params = useParams();
  const [editProfile, setEditProfile] = useState(false);

  const companySidebar = () => (
    <>
      <ul className="pl-0 text-left mt-5 side-link bo_bottom">
        <p>{messages.blog}</p>
        <li className="">
          <NavigationLink
            to={`/overview${params.companyId ? `/${params.companyId}` : ''}`}
            className="d-flex"
          >
            <span>
              <img src={CompanyIcon} alt="" />
            </span>
            {messages.overview}
            <b className="ml-auto mr-0">›</b>
          </NavigationLink>
        </li>
        <li className="">
          <NavigationLink
            to={`/company-posts${
              params.companyId ? `/${params.companyId}` : ''
            }`}
            className="d-flex"
          >
            <span>
              <img src={PostsIcon} alt="" />
            </span>
            {messages.post}
            <b className="ml-auto mr-0">›</b>
          </NavigationLink>
        </li>
        <li className="">
          <NavigationLink
            to={`/company-information${
              params.companyId ? `/${params.companyId}` : ''
            }`}
            className="d-flex"
          >
            <span>
              <img src={InformationIcon} alt="" />
            </span>
            {messages.information}
            <b className="ml-auto mr-0">›</b>
          </NavigationLink>
        </li>
      </ul>

      <ul className="pl-0 text-left mt-5 side-link bo_bottom">
        <p>{messages.management}</p>
        <li className="">
          <NavigationLink
            to={`/cloud${params.companyId ? `/${params.companyId}` : ''}`}
            className="d-flex"
          >
            <span>
              <img src={ReaderIcon} alt="" />
            </span>
            {messages.file}
            <b className="ml-auto mr-0">›</b>
          </NavigationLink>
        </li>
        {userDetails.isCompanyAdmin && (
          // userDetails.companyId ||
          // (role && role.title === 'admin' &&
          <>
            <li className="">
              <NavigationLink
                to={`/account${params.companyId ? `/${params.companyId}` : ''}`}
                className="d-flex"
              >
                <span>
                  <img src={AdminIcon} alt="" />
                </span>
                {messages.account}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
            <li className="">
              <NavigationLink
                to={`/analyse${params.companyId ? `/${params.companyId}` : ''}`}
                className="d-flex"
              >
                <span>
                  <img src={UserIcon} alt="" />
                </span>
                {messages.analyse}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          </>
        )}
      </ul>
    </>
  );

  const staffSidebar = () => (
    <>
      {showBlog ? (
        <ul className="pl-0 text-left mt-5 side-link bo_bottom">
          <p>{messages.blog}</p>
          {showBlogPost && (
            <li className="">
              <NavigationLink to="/posts/architectures" className="d-flex">
                <span>
                  <img src={PostsIcon} alt="" />
                </span>
                {messages.post}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
          {showBlogCompany && (
            <li className="">
              <NavigationLink to="/company" className="d-flex">
                <span>
                  <img src={CompanyIcon} alt="" />
                </span>
                {messages.company}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
          {showBlogInformation && (
            <li className="active">
              <NavigationLink to="/information-posts" className="d-flex">
                <span>
                  <img src={InformationIcon} alt="" />
                </span>
                {messages.information}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
        </ul>
      ) : null}

      {showBoard ? (
        <ul className="pl-0 text-left mt-5 side-link bo_bottom">
          <p>{messages.board}</p>
          {showBoardReader && (
            <li className="">
              <NavigationLink
                to="/readers"
                className="d-flex align-items-center"
              >
                <span>
                  <img src={ReaderIcon} alt="" />
                </span>
                {messages.reader}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
          {showBoardPartner && (
            <li className="">
              <NavigationLink
                to="/partners"
                className="d-flex align-items-center"
              >
                <span>
                  <img src={UserIcon} alt="" />
                </span>
                {messages.partner}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
          {showBoardAdmin && (
            <li className="">
              <NavigationLink to="/admin" className="d-flex align-items-center">
                <span>
                  <img src={AdminIcon} alt="" />
                </span>
                {messages.admin}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
          {showBoardEditor && (
            <li className="">
              <NavigationLink
                to="/editors"
                className="d-flex align-items-center"
              >
                <span>
                  <img src={EditorIcon} alt="editor icon" />
                </span>
                {messages.editor}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
          {showBoardSeller && (
            <li className="">
              <NavigationLink
                to="/seller"
                className="d-flex align-items-center"
              >
                <span>
                  <img src={SellerIcon} alt="seller icon" />
                </span>
                {messages.seller}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
          {showBoardJudge && (
            <li className="">
              <NavigationLink to="/judge" className="d-flex align-items-center">
                <span>
                  <img src={JudgeIcon} alt="judge icon" />
                </span>
                {messages.judge}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
        </ul>
      ) : null}

      {showCategory ? (
        <ul className="pl-0 text-left mt-5 side-link bo_bottom">
          <p>{messages.category}</p>
          {showCategoryPost && (
            <li>
              <NavigationLink to="/categories/posts" className="d-flex">
                <span>
                  <img src={PostsIcon} alt="" />
                </span>
                {messages.post}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
          {showCategoryCompany && (
            <li className="">
              <NavigationLink to="/categories/company" className="d-flex">
                <span>
                  <img src={CompanyIcon} alt="" />
                </span>
                {messages.company}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
          {showCategoryInformation && (
            <li>
              <NavigationLink to="/categories/information" className="d-flex">
                <span>
                  <img src={InformationIcon} alt="" />
                </span>
                {messages.information}
                <b className="ml-auto mr-0">›</b>
              </NavigationLink>
            </li>
          )}
        </ul>
      ) : null}
      {isAdmin(roles) && (
        <ul className="pl-0 text-left mt-5 side-link bo_bottom">
          <p>Sitemap</p>
          <li>
            <NavigationLink to="/page" className="d-flex">
              <span>
                <img src={NavigationIcon} alt="" />
              </span>
              {messages.page}
              <b className="ml-auto mr-0">›</b>
            </NavigationLink>
          </li>
          <li>
            <NavigationLink to="/navigation" className="d-flex">
              <span>
                <img src={PageIcon} alt="" />
              </span>
              {messages.navigation}
              <b className="ml-auto mr-0">›</b>
            </NavigationLink>
          </li>
          <li>
            <NavigationLink to="/navigation" className="d-flex">
              <span>
                <img src={PageIcon} alt="" />
              </span>
              Sidebar
              <b className="ml-auto mr-0">›</b>
            </NavigationLink>
          </li>
        </ul>
      )}
    </>
  );

  const readerSidebar = () => (
    <ul className="pl-0 text-left mt-5 side-link bo_bottom">
      <p>{messages.favorite}</p>
      <li className="">
        <NavigationLink to="/fav-posts" className="d-flex">
          <span>
            <img src={PostsIcon} alt="" />
          </span>
          {messages.post}
          <b className="ml-auto mr-0">›</b>
        </NavigationLink>
      </li>
      <li className="">
        <NavigationLink to="/fav-company" className="d-flex">
          <span>
            <img src={CompanyIcon} alt="" />
          </span>
          {messages.company}
          <b className="ml-auto mr-0">›</b>
        </NavigationLink>
      </li>
      <li className="active">
        <NavigationLink to="/fav-information-posts" className="d-flex">
          <span>
            <img src={InformationIcon} alt="" />
          </span>
          {messages.information}
          <b className="ml-auto mr-0">›</b>
        </NavigationLink>
      </li>
    </ul>
  );
  const judgeSidebar = () => <JudgeSidebarItems />;

  const renderSidebar = () => {
    if (editProfile) {
      return (
        <EditProfile
          userDetails={userDetails}
          setEditProfile={setEditProfile}
          isReader
        />
      );
    }
    if (isJudge(roles)) return judgeSidebar();
    if (isPartner(roles)) return companySidebar();
    if (isReader(roles)) return readerSidebar();
    return staffSidebar();
  };
  return (
    <div className="side-nav">
      <SidebarProfile
        onClick={() => {
          // if(!isPartner(roles) || isPartner(roles) && !userDetails.isCompanyAdmin)
          setEditProfile(!editProfile);
        }}
      />

      {renderSidebar()}
    </div>
  );
}
